import { render } from "./DeleteAppointment.vue?vue&type=template&id=7d336935&scoped=true&ts=true"
import script from "./DeleteAppointment.vue?vue&type=script&lang=ts"
export * from "./DeleteAppointment.vue?vue&type=script&lang=ts"

import "./DeleteAppointment.vue?vue&type=style&index=0&id=7d336935&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d336935"]])

export default __exports__